export const prevIcon = (
  <svg
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 70 70"
  >
    <circle cx="35" cy="35" r="35" fill="currentColor" />
    <path
      fill="#1a1a1a"
      d="M40.57 52.53 23.04 35l17.53-17.53 1.06 1.06L25.16 35l16.47 16.47-1.06 1.06z"
    />
  </svg>
);

export const nextIcon = (
  <svg
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 70 70"
  >
    <circle cx="35" cy="35" r="35" fill="currentColor" />
    <path
      fill="#1a1a1a"
      d="m29.43 52.53-1.06-1.06L44.84 35 28.37 18.53l1.06-1.06L46.96 35 29.43 52.53z"
    />
  </svg>
);
